// /app/frontend/src/pages/risk/dpia/steps/TransfersStep.jsx
import React from 'react';
import { Input } from '../../../../components/ui/input';
import { Label } from '../../../../components/ui/label';
import { Textarea } from '../../../../components/ui/textarea';
import { Card, CardContent } from '../../../../components/ui/card';
import { Check } from 'lucide-react';

export default function TransfersStep({ formData, updateField }) {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h3 className="text-lg font-semibold text-foreground">International Transfers</h3>
        <p className="text-sm text-muted-foreground">Document any transfers of personal data outside of your country</p>
      </div>

      <Card className="border border-border">
        <CardContent className="pt-6 space-y-4">
          {/* Yes/No Toggle */}
          <div className="space-y-3">
            <Label>Is Personal Data Transferred outside of the Country?</Label>
            <div className="flex gap-4">
              <div 
                onClick={() => updateField('international_transfer', true)}
                className={`
                  flex-1 p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 text-center
                  ${formData.international_transfer === true 
                    ? 'border-teal-500 bg-teal-50 dark:bg-teal-950/30' 
                    : 'border-border hover:border-teal-300'}
                `}
                data-testid="international-transfer-yes"
              >
                <div className="flex items-center justify-center gap-2">
                  <div className={`
                    w-5 h-5 rounded-full border-2 flex items-center justify-center
                    ${formData.international_transfer === true ? 'border-teal-500 bg-teal-500' : 'border-muted-foreground/50'}
                  `}>
                    {formData.international_transfer === true && <Check className="h-3 w-3 text-white" />}
                  </div>
                  <span className={`font-medium ${formData.international_transfer === true ? 'text-teal-700 dark:text-teal-300' : ''}`}>Yes</span>
                </div>
              </div>
              <div 
                onClick={() => {
                  updateField('international_transfer', false);
                  updateField('transfer_country', '');
                  updateField('international_transfer_details', '');
                  updateField('transfer_safeguards', '');
                }}
                className={`
                  flex-1 p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 text-center
                  ${formData.international_transfer === false 
                    ? 'border-teal-500 bg-teal-50 dark:bg-teal-950/30' 
                    : 'border-border hover:border-teal-300'}
                `}
                data-testid="international-transfer-no"
              >
                <div className="flex items-center justify-center gap-2">
                  <div className={`
                    w-5 h-5 rounded-full border-2 flex items-center justify-center
                    ${formData.international_transfer === false ? 'border-teal-500 bg-teal-500' : 'border-muted-foreground/50'}
                  `}>
                    {formData.international_transfer === false && <Check className="h-3 w-3 text-white" />}
                  </div>
                  <span className={`font-medium ${formData.international_transfer === false ? 'text-teal-700 dark:text-teal-300' : ''}`}>No</span>
                </div>
              </div>
            </div>
          </div>

          {formData.international_transfer === true && (
            <div className="space-y-4 pt-4 border-t border-border">
              <div className="space-y-2">
                <Label>Country <span className="text-red-500">*</span></Label>
                <Input 
                  value={formData.transfer_country}
                  onChange={(e) => updateField('transfer_country', e.target.value)}
                  placeholder="e.g., United States, United Kingdom, Canada..."
                  data-testid="transfer-country-input"
                />
              </div>
              <div className="space-y-2">
                <Label>Transfer Details <span className="text-red-500">*</span></Label>
                <p className="text-xs text-muted-foreground">Describe how the data would be transferred</p>
                <Textarea 
                  value={formData.international_transfer_details}
                  onChange={(e) => updateField('international_transfer_details', e.target.value)}
                  placeholder="Describe the transfer mechanism (e.g., API integration, email, cloud storage, physical transfer)..."
                  rows={4}
                  className="resize-none"
                  data-testid="transfer-details-textarea"
                />
              </div>
              <div className="space-y-2">
                <Label>Transfer Safeguards <span className="text-red-500">*</span></Label>
                <p className="text-xs text-muted-foreground">How is the data secured during and after transfer?</p>
                <Textarea 
                  value={formData.transfer_safeguards}
                  onChange={(e) => updateField('transfer_safeguards', e.target.value)}
                  placeholder="Standard contractual clauses, encryption, binding corporate rules, adequacy decisions..."
                  rows={4}
                  className="resize-none"
                  data-testid="transfer-safeguards-textarea"
                />
              </div>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
